<template>
    <div class="gh-page gh-page-summit">
        <div class="gh-confirmation gh-page-confirmation">
            <gh-header :isSuccess="true" />
            <div class="container">
                <div class="gh-confirmation-container">
                    <p class="gh-heading">Your registration was successful!</p>
                    <p class="gh-sub-heading pb-1">Thank you so much – you’ve booked your place in the 2022 Suicide Prevention Summit, and helped us raise funds for a very worthwhile cause!</p>
                    <div class="gh-body pb-1">
                        <p class="pb-1">Now that you’ve completed your registration, there are a few small house keeping items to attend to that’ll ensure your Summit experience is seamless and enjoyable.</p>
                        <p>We have sent you an email confirmation with some instructions – please check your <strong>inbox</strong> and <strong>junk mail</strong> folders, and <a href="mailto:help@mentalhealthacademy.co.uk">contact us</a> if you cannot locate the email.</p>
                        <ul class="ghList pt-1 pb-1 gh-confirmation-list">
                            <li class="ghList-item"><router-link target="_blank" to="/suicideprevention/invoice">Click here</router-link> to download your registration tax invoice.</li>
                            <li class="ghList-item"><a target="_blank" href="/suicideprevention#faqs">Read our frequently asked questions</a>. There you’ll find important Summit information, such as some of the technical requirements to access sessions.</li>
                            <li class="ghList-item">Help us spread the word about the event via email (to your professional peers) and on social media.</li>
                        </ul>
                        <p>
                            If you have any queries, <a href="mailto:help@mentalhealthacademy.co.uk ">email us</a> and we’ll respond as quickly as possible. In the meantime, we’ll keep in touch with you via email updates, including instructions on how to access and follow the Summit, which will be sent to you closer to the event dates.
                        </p>
                        <p class="pt-1">
                            Until then, good-bye, and thank you again for your support.
                        </p>
                        <p class="pt-1 pb-2">
                            Kind regards,
                        </p>
                        <img src="/images/suicidePreventionSummit/Signature.png" border="0" />
                        <p class="pt-1 mb-2">
                            Pedro Gondim<br>
                            Chief Executive Officer<br>
                            Mental Health Academy
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <gh-sponsors class="bg-pale-grey"/>
    </div>
</template>

<script>
    import ghHeader from '@/modules/events/suicidePreventionSummit/components/TheHeader'
    import ghSponsors from '@/modules/events/suicidePreventionSummit/components/Sponsors'

    export default {
        components: {
            ghHeader,
            ghSponsors
        }
    }
</script>
<style lang="scss" src="~/sass/pages/landing/summit.scss">
    @import url('https://fonts.googleapis.com/css?family=Catamaran');
</style>
<style scoped lang="scss">
    a, button, p, span, div, li {
        font-family: Catamaran,sans-serif !important;
    }
    .pb-2 {
        padding-bottom: 2rem;
    }

    .pt-1 {
        padding-top: 1rem;
    }

    .pt-2 {
        padding-top: 2rem;
    }

    .gh-confirmation {
        .gh-confirmation-list {
            padding-left: 2rem;
            padding-bottom: 1rem;
            font-size: 1.2rem;
        }
        img {
            width: 150px;
        }
        .gh-heading {
            font-size: 2.5rem;
            margin-top: 2rem;
            margin-bottom: 20px;
            font-weight: 500;
            color: #f76c6c;
        }
        .gh-sub-heading {
            font-size: 1.5rem;
            font-weight: 600;
        }
        .gh-body {
            p {
                font-size: 1.2rem;
            }
        }
        .gh-confirmation-container {
            max-width: 800px;
            @media(max-width:1112px) {
                margin: 0 auto;
            }
        }
    }
</style>

<style lang="scss">
    .bg-pale-grey {
        background: #f5f7fa;
    }
    .gh-page-confirmation {
        background: white;
        .gh-header {
            margin-left: -2rem;

            .gh-container {
                padding: 0 4rem !important;
            }

            .gh-logos .gh-logo-act {
                // display: block !important;
            }
        }
    }
</style>
